import { html as t } from "@microsoft/fast-element";
import { startSlotTemplate as a, endSlotTemplate as r } from "@matrix42/fast-foundation";
const p = (o) => {
  const e = t.partial(o.prefix);
  return t`
    <div class="control" part="control">
      ${a({})}
      <span class="content" part="content">
        <slot></slot>
      </span>
      ${r({})}
      <${e}-icon
        class="dispose-button"
        name="x-mark"
        @click="${(s) => s.dispose()}"
        size="1em"
      />
    </div>
  `;
};
export {
  p as tagTemplate
};
